import axios from "@/plugins/axios";
// import * as example from "./example";

let url = "/api/v1/me/logout";

export const logout = {
    // ...example,
    delete(data){
        console.log(data)
        return axios.delete(`${url}`).then(result => result.data);
    }
}
